<div class="modal-header header">
    <h3 class="title">{{title}}</h3>
    <button unity-button class="icon-only xlarge on_dark" type="button"
        aria-labelledby="unity-icon-button-label-close" (click)="onClose.emit()">
        <span id="unity-icon-button-label-close" hidden>Close</span>
        <svg class="unity-icon-times" aria-hidden="true">
            <use xlink:href="#unity-icon-times"></use>
        </svg>

    </button>
</div>
<div class="modal-body body" [ngClass]="{'no-footer': hideFooter}">
    <ng-content></ng-content>
</div>
@if (!hideFooter) {
    <div class="modal-footer footer">
        <!-- Just conforming unity-modal to aurora, which doesn't make sense, but saves a lot of time in this stage. We'll have to migrate
             all modals to aurora-modal when we decide to remove the switch -->
        <ng-container *sm-has-not-env-flag="'auroraV1'">
            <div class="back">
                <button *ngIf="backAction" unity-button class="ghost" type="button" (click)="onBackAction.emit()">
                    <span class="label">{{backAction}}</span>
                </button>
            </div>
            <div class="actions">
                <button *ngIf="primaryAction" unity-button id="PrimaryButton" class="primary" type="button" [disabled]="!primaryActionEnabled" (click)="onPrimaryAction.emit()">
                    <span class="label">{{primaryAction}}</span>
                </button>
                <button *ngIf="secondaryAction" unity-button id="SecondaryButton" class="secondary" type="button" [disabled]="!secondaryActionEnabled" (click)="onSecondaryAction.emit()">
                    <span class="label">{{secondaryAction}}</span>
                </button>
                <button *ngIf="tertiaryAction" unity-button class="ghost" type="button" [disabled]="!tertiaryActionEnabled" (click)="onTertiaryAction.emit()">
                    <span class="label">{{tertiaryAction}}</span>
                </button>
            </div>
        </ng-container>
        <ng-container *sm-has-env-flag="'auroraV1'">
            <div class="back">
                <aurora-button *ngIf="backAction" variant="ghost" type="button" (click)="onBackAction.emit()">
                    <span class="label">{{backAction}}</span>
                </aurora-button>
            </div>
            <div class="actions">
                <aurora-button *ngIf="primaryAction" variant="primary" type="button" [disabled]="!primaryActionEnabled" (click)="onPrimaryAction.emit()">
                    <span class="label">{{primaryAction}}</span>
                </aurora-button>
                <aurora-button *ngIf="secondaryAction" variant="secondary" type="button" [disabled]="!secondaryActionEnabled" (click)="onSecondaryAction.emit()">
                    <span class="label">{{secondaryAction}}</span>
                </aurora-button>
                <aurora-button *ngIf="tertiaryAction" variant="ghost" type="button" [disabled]="!tertiaryActionEnabled" (click)="onTertiaryAction.emit()">
                    <span class="label">{{tertiaryAction}}</span>
                </aurora-button>
            </div>
        </ng-container>
    </div>
}
